<template>
  <div>
    <div v-if="mainStore.project.state === 'pending_activation'">
      <StepTitle value="Plus qu'une étape&nbsp;!" />
      <p class="text-lg font-medium text-dark">
        Confirmez votre email en cliquant sur le lien que nous venons de vous envoyer.
      </p>
      <img :src="require('./../assets/enveloppe.jpg')" alt="Nouveau message" class="mb-8 w-72" />
      <div v-if="mainStore.project.resendConfirmationUrl">
        <span v-if="confirmationState === 'sent'" class="small">Email envoyé&nbsp;!</span>
        <span v-if="confirmationState === 'errored'" class="small">Impossible d'envoyer la confirmation</span>
        <div v-if="confirmationState === 'sendable'">
          <p class="small m-0">Vous n'avez pas reçu l'email sur {{ mainStore.user.email }} ?</p>
          <p>
            Vérifiez vos spams ou
            <a :href="mainStore.project.resendConfirmationUrl" class="inline" @click="sendConfirmation">
              <fa-icon type="far" icon="redo-alt" />
              Renvoyer la confirmation
            </a>
          </p>
        </div>
      </div>
      <button class="btn btn-primary btn-lg mt-6 px-12" @click="$root.close">Fermer</button>
    </div>
    <div v-else>
      <img :src="require('./../assets/success.jpg')" alt="Succès !" class="mb-6 w-72" />
      <div v-if="['pending_publication', 'processing_pending_publication'].includes(mainStore.project.state)">
        Votre projet a bien été enregistré et est en cours de validation
      </div>
      <div v-else-if="mainStore.project.state === 'publishing'">
        Félicitation, votre projet est en cours de publication&nbsp;!
        <br />
        Il sera publié dans quelques minutes
      </div>
      <div v-else-if="mainStore.project.state === 'published'">Félicitation, votre projet est publié&nbsp;!</div>
      <div v-else-if="mainStore.project.state === 'pending_payment'">
        Votre projet a bien été enregistré et est en attente du paiement des options payantes choisies
      </div>
      <a class="btn btn-primary btn-lg mt-12" :href="mainStore.project.url" @click="$root.close">Voir mon projet</a>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'

export default {
  data() {
    return {
      confirmationState: 'sendable'
    }
  },
  computed: {
    ...mapStores(useMainStore)
  },
  methods: {
    sendConfirmation(event) {
      event.preventDefault()
      event.stopPropagation()
      this.$http.post(event.target.href).then(
        function () {
          this.confirmationState = 'sent'
          setTimeout(() => (this.confirmationState = 'sendable'), 600000)
        },
        function () {
          this.confirmationState = 'errored'
          setTimeout(() => (this.confirmationState = 'sendable'), 45000)
        }
      )
    }
  }
}
</script>
